"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferFormToPayloadDataHandler = transferFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function transferFormToPayloadDataHandler(data) {
    var _a, _b, _c;
    const now = (0, dayjs_1.default)();
    return {
        form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ dateOfTransfer: data.dateOfTransfer, hospitalTransferredTo: data.hospitalTransferredTo || "", reasonForTransfer: data.reasonForTransfer || "" }, (data.caseManagerAtHospital && {
            caseManagerAtHospital: data.caseManagerAtHospital,
        })), (((_a = data === null || data === void 0 ? void 0 : data.phoneNumberWithCountryCode) === null || _a === void 0 ? void 0 : _a.phoneNumber) && {
            phoneNumberToCaseManager: `${data === null || data === void 0 ? void 0 : data.phoneNumberWithCountryCode.phoneNumber}`,
        })), (((_b = data === null || data === void 0 ? void 0 : data.phoneNumberWithCountryCode) === null || _b === void 0 ? void 0 : _b.countryCode) && {
            countryCode: (_c = data === null || data === void 0 ? void 0 : data.phoneNumberWithCountryCode) === null || _c === void 0 ? void 0 : _c.countryCode,
        })), (data.faxNumberToHospital && {
            faxNumberToHospital: data.faxNumberToHospital,
        })), (data.notes && { comments: data.notes })), (data.physicianNotified !== undefined && {
            physicianNotified: data.physicianNotified,
        })), { offSet: now.utcOffset() }),
    };
}
